<section
  *ngIf="error"
  class="plan-limit-banner"
  [class.plan-limit-banner--compact]="compact"
  role="alert">
  <i class="fas fa-lock" aria-hidden="true"></i>
  <div class="plan-limit-banner__body">
    <strong>{{ 'enforcement.banner.title' | translate }}</strong>
    <p>{{ 'enforcement.banner.body' | translate }}</p>
    <span *ngIf="error.limitCode">{{ error.limitCode | limitLabel }}</span>
  </div>
  <a routerLink="/usage" class="btn btn-sm btn-outline-primary">
    {{ 'enforcement.banner.cta' | translate }}
  </a>
  <button
    type="button"
    class="plan-limit-banner__close"
    (click)="dismissed.emit()"
    [attr.aria-label]="'common.close' | translateOr: 'Cerrar'">
    <i class="fas fa-times" aria-hidden="true"></i>
  </button>
</section>
